module.exports = __webpack_public_path__ + "static/media/logo.f665e361.jpg";